export default __webpack_public_path__ + "static/media/empty-shop.e78970f0.e78970f0.svg";